import { useEffect, useState } from 'react';
import { Grid, Layout } from 'antd';
import { Outlet } from 'react-router-dom';

import Footer from '@layout/Footer/Footer';
import Sidebar from '@layout/Sidebar/Sidebar';
import Header from '@layout/Header/Header';
import styles from './MainLayout.module.css';

const { Content } = Layout;
const { useBreakpoint } = Grid;

const MainLayout = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const screens = useBreakpoint();
  const isMobile = !screens.lg;

  useEffect(() => {
    if (!isMobile && mobileMenuOpen) {
      setMobileMenuOpen(false);
    }
  }, [isMobile, mobileMenuOpen]);

  const handleMenuClick = () => {
    if (isMobile) {
      setMobileMenuOpen(prev => !prev);
      return;
    }
    setCollapsed(prev => !prev);
  };

  const handleMobileMenuClose = () => {
    setMobileMenuOpen(false);
  };

  return (
    <Layout className={styles.layoutRoot}>
      <Sidebar
        collapsed={collapsed}
        isMobile={isMobile}
        mobileOpen={mobileMenuOpen}
        onMobileClose={handleMobileMenuClose}
      />
      <Layout className={styles.layoutMain}>
        <Header
          onMenuClick={handleMenuClick}
          collapsed={isMobile ? !mobileMenuOpen : collapsed}
          isMobile={isMobile}
        />
        <Content className={styles.contentViewport}>
          <div className={styles.contentInner}>
            <Outlet />
          </div>
        </Content>
        <Footer />
      </Layout>
    </Layout>
  );
};

export default MainLayout;
